import { ListItem } from '@awazevr/design-system.components.list-item'
import { Text } from '@awazevr/design-system.components.text'

import {
  StyledDivider,
  StyledFromLabel,
  StyledNights,
  StyledPriceInfo,
  StyledStartDate,
} from './Availability.styles'

const DEFAULT_LENGTH_OF_STAY = 7

export type AvailabilityProps = {
  startDate?: string | null
  lengthOfStay: number
  nightsLabel: string
  fromLabel?: string
  showFromLabel?: boolean
  showStartDate?: boolean
  hasFromPrice?: boolean
}

export const Availability = ({
  startDate,
  lengthOfStay,
  nightsLabel,
  fromLabel,
  showFromLabel = true,
  showStartDate = true,
  hasFromPrice = false,
}: AvailabilityProps): JSX.Element => {
  const nights = lengthOfStay > 0 ? lengthOfStay : DEFAULT_LENGTH_OF_STAY
  const shouldShowStartDate = !!startDate && showStartDate

  return (
    <StyledPriceInfo>
      {shouldShowStartDate && (
        <>
          <ListItem size="small">
            <StyledStartDate sizes={300}>{startDate}</StyledStartDate>
          </ListItem>
          <ListItem>
            <StyledDivider aria-hidden="true">•</StyledDivider>
          </ListItem>
        </>
      )}

      <ListItem size="small">
        {hasFromPrice ? (
          <Text sizes={200}>
            {nights}&nbsp;
            {nightsLabel}&nbsp;
          </Text>
        ) : (
          <StyledNights sizes={300}>
            {nights}&nbsp;
            {nightsLabel}&nbsp;
          </StyledNights>
        )}
        {showFromLabel && hasFromPrice && fromLabel && (
          <StyledFromLabel sizes={200}>{fromLabel}</StyledFromLabel>
        )}
      </ListItem>
    </StyledPriceInfo>
  )
}
